export default __webpack_public_path__ + "static/media/undraw_Calendar_dark.5d6ca358.svg";